// extracted by mini-css-extract-plugin
module.exports = {"message":"messageBoard_message__d8J6J","content":"messageBoard_content__YIJ9m","alignLeft":"messageBoard_alignLeft__SJV5V"};